import { createRouter, createWebHistory } from 'vue-router'
import NProgress from '@/utils/nprogress'
// 引入不需要权限的modules
import system from './modules/system'
import store from "@/store";
let modules = [
    ...system
]
const router = createRouter({
    history: createWebHistory('/'),
    routes: modules
})
// 未授权时可访问的白名单
const whiteList = ["/login",'/404']
// 路由跳转前的监听操作
router.beforeEach((to, _from, next) => {
    NProgress.start();
    if (store.state.user.token) {
        if (to.path === '/login') {
            next('/')
            return
        }
        if (!to.matched.length) { // 没有匹配到任何路由
            next('/404') // 跳转到 401 页面
            return
        }
        next()
        return
    }
    if (!to.matched.length) { // 没有匹配到任何路由
        next('/404') // 跳转到 401 页面
        return
    }
    if (whiteList.includes(to.path)) {
        next()
        return
    }
    next("/login"); // 全部重定向到登录页
});
// 路由跳转后的监听操作
router.afterEach(() => {
    NProgress.done()
});
export default router
